const selector = "[data-filtered-carousel]";

let els = null;

function FilteredCarousels() {

	// Search for carousel elements on page
	els = document.querySelectorAll(selector);

	// If there are any, continue
	if (els.length) {
		init();
	}
}

const init = () => {

	// Loop through them
	[].forEach.call(els, function(item) {
		
		// Add event listener for custom event dispatched by tab link
		item.addEventListener("tab-clicked", function(e) {
			console.log(e.detail.tabId);
			
		});

	});
}

export default FilteredCarousels;